module.exports = __webpack_public_path__ + "img/g2a.3c12d0e5.png";